export default "__VITE_ASSET__DuGQ52F3__"